/**
 * Dónde está parada la pantalla, y llevarla a otro lado.
 *
 * ## Para qué
 *
 * Una lista de setenta clientes no entra en un teléfono. Tocar el de abajo de
 * todo abría su ficha arriba de la pantalla, fuera de la vista: el gesto no
 * mostraba nada y parecía que la aplicación estaba rota. Hasta que uno
 * descubría, scrolleando, que lo que pidió estaba allá arriba.
 *
 * Abrir algo tiene que llevar la vista a lo que se abrió, y cerrarlo tiene que
 * devolverla al renglón que se tocó. Si no, la lista se pierde cada vez y hay
 * que volver a bajar setenta nombres.
 *
 * ## Por qué `scrollingElement` y no `window.scrollTo`
 *
 * Hacen lo mismo en el teléfono, pero `window.scrollTo` no existe de verdad en
 * el entorno de las pruebas: cada llamada ensucia la salida con un «not
 * implemented». Mover `scrollTop` del elemento raíz es silencioso ahí y
 * equivalente acá, así que las pruebas pueden mirar esto sin ruido.
 */

/** El elemento que scrollea en esta aplicación: el documento entero. */
const raiz = (): Element => document.scrollingElement ?? document.documentElement;

/** A qué altura está la pantalla, para poder volver después. */
export const dondeEstaLaPantalla = (): number => raiz().scrollTop;

/** Llevar la pantalla a una altura. `0` es arriba de todo. */
export function llevarLaPantallaA(y: number): void {
  raiz().scrollTop = y;
}
